/** Texto común para Problem Details de lecturas y escrituras. */
export function mensajeProblema(error: unknown, status?: number): string {
  const fields =
    error && typeof error === "object"
      ? (error as Record<string, unknown>)
      : {};
  const code = typeof fields.code === "string" ? fields.code : "";
  const detail =
    typeof fields.detail === "string"
      ? fields.detail
      : typeof fields.title === "string"
        ? fields.title
        : "";
  const prefix =
    status === 401
      ? "Sesión vencida. Vuelve a entrar. "
      : status === 403
        ? "Sin permiso para esta sede u operación. "
        : "";
  return `${prefix}${code ? `${code}: ` : ""}${detail || (status ? `La API respondió ${status}.` : "Error de red.")}`;
}
